class Currency {
  constructor(value, currency) {
    this.value = value;
    this.currency = currency;
  }

  format(lang) {
    return this.value.toLocaleString(lang, {
      style: 'currency',
      currency: this.currency,
    });
  }
}

export { Currency };
